/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
/**
 *
 * @export
 * @interface FromTemplate
 */
export interface FromTemplate {
  /**
   * source simulation template id
   */
  template: string;
  /**
   * ThreediModel to copy template to
   */
  threedimodel?: string;
  /**
   *
   */
  name: string;
  /**
   *
   */
  tags?: Array<any>;
  /**
   * The unique_id of an organisation
   */
  organisation: string;
  /**
   *
   */
  startDatetime: Date;
  /**
   *
   */
  endDatetime?: Date;
  /**
   *
   */
  duration?: number;
  /**
   *
   */
  cloneEvents?: boolean;
  /**
   *
   */
  cloneInitials?: boolean;
  /**
   *
   */
  cloneSettings?: boolean;
  /**
   *
   */
  startedFrom?: string;
}

/**
 * Check if a given object implements the FromTemplate interface.
 */
export function instanceOfFromTemplate(value: object): value is FromTemplate {
  if (!("template" in value) || value["template"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("organisation" in value) || value["organisation"] === undefined) return false;
  if (
    (!("startDatetime" in (value as Record<string, any>)) &&
      !("start_datetime" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["startDatetime"] === undefined &&
      (value as Record<string, any>)["start_datetime"] === undefined)
  )
    return false;
  return true;
}

export function FromTemplateFromJSON(json: any): FromTemplate {
  return FromTemplateFromJSONTyped(json, false);
}

export function FromTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): FromTemplate {
  if (json == null) {
    return json;
  }
  return {
    template: json["template"],
    threedimodel: json["threedimodel"] == null ? undefined : json["threedimodel"],
    name: json["name"],
    tags: json["tags"] == null ? undefined : json["tags"],
    organisation: json["organisation"],
    startDatetime:
      json["start_datetime"] == null
        ? json["start_datetime"]
        : parseDateTime(json["start_datetime"]),
    endDatetime: json["end_datetime"] == null ? undefined : parseDateTime(json["end_datetime"]),
    duration: json["duration"] == null ? undefined : json["duration"],
    cloneEvents: json["clone_events"] == null ? undefined : json["clone_events"],
    cloneInitials: json["clone_initials"] == null ? undefined : json["clone_initials"],
    cloneSettings: json["clone_settings"] == null ? undefined : json["clone_settings"],
    startedFrom: json["started_from"] == null ? undefined : json["started_from"],
  };
}

export function FromTemplateToJSON(json: any): FromTemplate {
  return FromTemplateToJSONTyped(json, false);
}

export function FromTemplateToJSONTyped(
  value?: FromTemplate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    template: value["template"],
    threedimodel: value["threedimodel"],
    name: value["name"],
    tags: value["tags"],
    organisation: value["organisation"],
    start_datetime:
      value["startDatetime"] == null
        ? value["startDatetime"]
        : serializeDateTime(value["startDatetime"]),
    end_datetime:
      value["endDatetime"] == null ? value["endDatetime"] : serializeDateTime(value["endDatetime"]),
    duration: value["duration"],
    clone_events: value["cloneEvents"],
    clone_initials: value["cloneInitials"],
    clone_settings: value["cloneSettings"],
    started_from: value["startedFrom"],
  };
}
